import { Decimal } from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

export const calcCvSteam = (massFlowString: string, inletPsiString: string, isModulating: boolean) => {
    try {
        const massFlow = new Decimal(massFlowString);
        const inlet = new Decimal(inletPsiString);
        if (inlet.equals(0)) {
            return '';
        }
        let pressureDrop = new Decimal(0);
        if (isModulating) {
            pressureDrop = inlet.greaterThan(15)
                ? new Decimal(0.42).mul(inlet.plus(14.7))
                : inlet.mul(0.8);
        } else {
            pressureDrop = inlet.mul(0.1);
        }
        const outlet = inlet.minus(pressureDrop).plus(14.7);

        return massFlow
            .dividedBy(pressureDrop
                .mul(outlet)
                .pow(0.5)
                .mul(new Decimal(3)))
            .toFixed(DECIMAL_DIGITS);
    } catch {
        return '';
    }
};
